<template>
  <div class="plv-ia-pre-redpacket-detail">
    <div class="plv-ia-pre-redpacket-detail-header">
      <span class="plv-ia-pre-redpacket-detail-status">{{ t('plvIA.redpacket.statusNoSend') }}</span>
      <span class="plv-ia-pre-redpacket-detail-title">{{ preRedpacketDetail.redpackName }}</span>
    </div>
    <div class="plv-ia-pre-redpacket-detail-line">
      <div class="plv-ia-pre-redpacket-detail-line-name">
        {{ t('plvIA.redpacket.preRedpacketType') }}
      </div>
      <div class="plv-ia-pre-redpacket-detail-line-value">
        {{ preRedpacketDetail.redPackTypeTitle }}
      </div>
    </div>
    <div class="plv-ia-pre-redpacket-detail-line">
      <div class="plv-ia-pre-redpacket-detail-line-name">
        {{ t('plvIA.redpacket.preRedpacketAccount') }}
      </div>
      <div class="plv-ia-pre-redpacket-detail-line-value">
        {{ redpackAmountNum.amountTitle }}
      </div>
    </div>
    <div class="plv-ia-pre-redpacket-detail-line">
      <div class="plv-ia-pre-redpacket-detail-line-name">
        {{ t('plvIA.redpacket.preRedpacketQuantity') }}
      </div>
      <div class="plv-ia-pre-redpacket-detail-line-value">
        {{ redpackAmountNum.numTitle }}
      </div>
    </div>
    <div class="plv-ia-pre-redpacket-detail-line">
      <div class="plv-ia-pre-redpacket-detail-line-name">
        {{ t('plvIA.redpacketRain.distribution') }}
      </div>
      <div class="plv-ia-pre-redpacket-detail-line-value">
        {{ preRedpacketDetail.methodsTitle }}
      </div>
    </div>
    <div class="plv-ia-pre-redpacket-detail-line">
      <div class="plv-ia-pre-redpacket-detail-line-name">
        {{ t('plvIA.redpacket.preRedpacketStatus') }}
      </div>
      <div class="plv-ia-pre-redpacket-detail-line-value plv-ia-pre-redpacket-status-msg">
        {{ preRedpacketDetail.statusTitle }} {{ expiredTimeText(preRedpacketDetail.expiredTime) }}
      </div>
    </div>
    <template v-if="preRedpacketDetail.redPackType.includes('PASSWORD')">
      <div class="plv-ia-pre-redpacket-detail-line">
        <div class="plv-ia-pre-redpacket-detail-line-name">
          {{ t('plvIA.redpacket.preRedpacketPwd') }}
        </div>
        <div class="plv-ia-pre-redpacket-detail-line-value">
          {{ preRedpacketDetail.passwd }}
        </div>
      </div>
      <div class="plv-ia-pre-redpacket-detail-line">
        <div class="plv-ia-pre-redpacket-detail-line-name">
          {{ t('plvIA.redpacket.prePwdTip') }}
        </div>
        <div class="plv-ia-pre-redpacket-detail-line-value">
          {{ preRedpacketDetail.greeting || t('plvIA.redpacket.pwdTipDefault') }}
        </div>
      </div>
    </template>
    <div v-else class="plv-ia-pre-redpacket-detail-line">
      <div class="plv-ia-pre-redpacket-detail-line-name">
        {{ t('plvIA.redpacket.preRedpacketCoverText') }}
      </div>
      <div class="plv-ia-pre-redpacket-detail-line-value">
        {{ preRedpacketDetail.greeting }}
      </div>
    </div>

    <div class="plv-ia-pre-redpacket-detail-btn-group">
      <button class="plv-ia-pre-redpacket-detail-btn--back plv-ia-pre-redpacket-btn-group-btn" @click="$emit('change-current-step', step.preRedpacket)"> {{ t('plvIA.redpacket.btnBack') }} </button>
      <button class="plv-ia-pre-redpacket-detail-btn--confirm plv-ia-pre-redpacket-btn-group-btn" @click="sendPreRedpacket"> {{ t('plvIA.redpacket.btnConfirm') }} </button>
    </div>
  </div>
</template>

<script>
import Locale from '@/mixins/locale';
import { step } from '../config';
import { formatDate } from '@polyv/utils/src/date';
import commonMixin from '../../app-mixin';
export default {
  name: 'pre-redpacket-detail',
  mixins: [Locale, commonMixin],
  props: {
    preRedpacketDetail: {
      type: Object
    }
  },
  data() {
    return {
      step,
    };
  },
  computed: {
    redpackAmountNum() {
      const { preRedpacketDetail } = this;
      const preYuan = this.t('plvIA.redpacket.preYuan2');
      const preGe = this.t('plvIA.redpacket.preGe');
      const redpackAmountNum = {
        amountTitle: '',
        numTitle: '',
      };
      if (preRedpacketDetail.allotType === 'average') {
        const amountList = [];
        const numList = [];
        preRedpacketDetail.averageList.forEach(obj => {
          amountList.push(`${obj.redPackAmount}${preYuan}`);
          numList.push(`${obj.redPackCount}${preGe}`);
        });
        redpackAmountNum.amountTitle = amountList.join(';');
        redpackAmountNum.numTitle = numList.join(';');
      } else {
        redpackAmountNum.amountTitle = `${preRedpacketDetail.amount}${preYuan}`;
        redpackAmountNum.numTitle = `${preRedpacketDetail.redPackCount}${preGe}`;
      }
      return redpackAmountNum;
    }
  },
  methods: {
    formatDate,
    expiredTimeText(date) {
      const dateText = formatDate(date, 'YYYY-MM-DD hh:mm');
      return this.t('plvIA.redpacket.preExpiredTimeText', { date: dateText });
    },
    sendPreRedpacket() {
      this.$emit('send-pre-redpacket', this.preRedpacketDetail);
    },
  }
};
</script>

<style lang="scss">
body[data-lang=en] {
  .plv-ia-pre-redpacket-detail-line-name {
    width: 120px;
  }
}
.plv-ia-pre-redpacket-detail {
  width: 420px;
  margin: auto;
  padding-top: 40px;
  .plv-ia-pre-redpacket-send-success {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 200px;
    img {
      width: 116px;
      height: 116px;
    }
    .plv-ia-pre-redpacket-send-success-msg {
      margin: 0;
      font-size: 18px;
      color: #333;
    }
  }
  .plv-ia-pre-redpacket-detail-header {
    margin-bottom: 24px;
    display: flex;
    .plv-ia-pre-redpacket-detail-status {
      transform: translateY(4px);
      color: #FFFFFF;
      font-size: 12px;
      margin-right: 10px;
      background: #45ACFF;
      border-radius: 2px;
      padding: 0 4px;
      text-align: center;
      height: 18px;
      line-height: 18px;
    }
    .plv-ia-pre-redpacket-detail-title {
      display: inline-block;
      color: black;
      font-size: 16px;
      font-weight: bold;
      margin-right: 10px;
      flex: 1;
      line-height: 26px;
      vertical-align: top;
    }
  }

  .plv-ia-pre-redpacket-detail-line {
    display: flex;
    margin-bottom: 14px;
    font-size: 14px;
    .plv-ia-pre-redpacket-detail-line-name {
      color: #677a80;
      width: 80px;
      text-align: right;
    }
    .plv-ia-pre-redpacket-detail-line-value {
      color: #000000;
      margin-left: 10px;
    }
    .plv-ia-pre-redpacket-status-msg {
      color: #2196F3;
    }
  }
  .plv-ia-pre-redpacket-detail-btn-group {
    margin: 40px 0 0;
    text-align: center;
    .plv-ia-pre-redpacket-btn-group-btn:hover {
      opacity: 0.8;
    }
  }
  .plv-ia-pre-redpacket-btn-group-btn {
    height: 32px;
    line-height: 32px;
    padding: 0 20px;
    background: #2196f3;
    font-size: 14px;
    color: #ffffff;
    border-radius: 18px;
    border: none;
    outline: none;
    cursor: pointer;
    min-width: 96px;
  }
  .plv-ia-pre-redpacket-detail-btn--back {
    border: 1px solid #2196F3;
    background: #ffffff;
    color: #2196F3;
    margin-right: 24px;
  }
  .plv-ia-pre-redpacket-detail-btn--confirm {
    border: 0;
  }
}
</style>
